import { fetchPagesReferencedBySourceId } from '@api/editorialLayout/pageAdmin';
import useLoad from '@hooks/useLoad';

const useReferencedByQuery = (entityType: string, entityId: string) =>
  useLoad(() => fetchPagesReferencedBySourceId(entityId), ['references', entityType, entityId], {
    refetchOnCountryChange: false,
    refetchOnDisableCache: false,
    refetchOnReconnect: true,
    refetchOnSearchLanguageChange: false,
    refetchOnWindowFocus: true,
  });

export default useReferencedByQuery;
